import { fetch } from '@atlassian/eoc-fetch';
import type { ResponderItemResponse } from '@atlassian/eoc-responder-names';

import type { GetTeamResponse } from './types';

// In some edge cases, it is possible that this endpoint returns multiple responders with the same id.
// In this case, we should filter out the deleted responders.
export const getTeam = (teamId: string): Promise<ResponderItemResponse | undefined> =>
	fetch<GetTeamResponse>(`/v1/alerts/responders/names`, {
		method: 'POST',
		body: {
			responders: [{ id: teamId, type: 'team' }],
		},
	}).then((response) => response.values.filter((responder) => !responder.deleted).at(0));
